import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container } from 'react-bootstrap';
import api from '../lib/api';

export default function PasswordResetRequestPage() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setMsg('');
    try {
      const res = await api.post('/accounts/password-reset/request/', {
        email,
        reset_base_url: `${window.location.origin}/reset-password/confirm`,
      });
      setMsg(res.data?.message || 'Reset email sent');
    } catch (ex) {
      setErr(ex?.response?.data?.error || 'Unable to request reset');
    }
  };

  return (
    <Container style={{ maxWidth: 520, marginTop: 60 }}>
      <Card className="p-4">
        <h5>Reset Password</h5>
        {msg && <Alert variant="success">{msg}</Alert>}
        {err && <Alert variant="danger">{err}</Alert>}
        <Form onSubmit={submit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Form.Group>
          <Button type="submit">Send reset link</Button>
        </Form>
      </Card>
    </Container>
  );
}
